import { NgModule } from '@angular/core';
import { MdlModule } from '@angular-mdl/core';
import { MdlSelectModule } from '@angular-mdl/select';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from "@angular/material";
import { MbscModule, mobiscroll } from "@mobiscroll/angular";
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { AngularDraggableModule } from 'angular2-draggable';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { NgIdleModule } from '@ng-idle/core';

import { SettingsMenuModule } from './shared/components/settings/settings-menu/settings-menu.module';
import { PracticeAppRoutingModule } from './practice-app-routing.module';
import { HeaderNavModule } from './shared/components/header-nav/header-nav.module';
import { CopyrightFooterModule } from './shared/components/copyright-footer/copyright-footer.module';
import { DeleteComponentModule } from './shared/components/delete/delete.module';
import { MenubarModule } from './shared/components/menubar/menubar.module';
import { PaginationModule } from './shared/components/pagination/pagination.module';
import { ModalModule } from './shared/components/modal/modal.module';
import { PatientAppViewModule } from './patient-app-view/patient-app-view.module';
import { TranslateModule } from './translate/translate.module';
import { PipeModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';
import { CommunicationMenuModule } from './shared/components/communications/communication-menu.module';
import { PaymentMenuModule } from './shared/components/payments/payment-menu.module';
import { ImageCropperModule } from './shared/modules/image-cropper.module';
import { ChangePasswordModule } from './shared/components/settings/change-password/change-password.module';
import { NotFoundModule } from './404/notFound.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { StripeAddNewPaymentModule } from './shared/components/stripe-add-new-payment/stripe-add-new-payment.module';

import { PaginationConfig } from './shared/components/pagination/pagination.config';

import { PracticeAppComponent } from './practice-app.component';
import { FollowUpCommunicationComponent } from './follow-up-communication/follow-up-communication.component';
import { VirtualCommunicationFollowUpComponent } from './virtual-communication-follow-up/virtual-communication-follow-up.component';
import { PatientOrthoFollowUpCommunicationComponent } from './patient-ortho-follow-up/patient-ortho.component';
import { RecentExpiredQuotesComponent } from './recent-expired-quotes/recent-expired-quotes.component';
import { NonStartFollowUpCommunicationComponent } from './non-start-follow-up/non-start-follow-up.component'
import { ParentOrthoFollowUpCommunicationComponent } from './parent-ortho-follow-up/parent-ortho.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { StatementsComponent } from './statements/statements.component';
import { ProfileComponent } from './profile/profile.component';
import { CartComponent } from './cart/cart.component';
import { CartSuccessComponent } from './cart-success/cart-success.component';
import { DocusignComponent } from './docusign/docusign.component';
import { DocusignApprovalCompleteComponent } from './docusign-approval-complete/docusign-approval-complete.component';
import { ContractCallback } from './contract-callback/contract-callback.component';
import { StripeComponent } from './stripe/stripe.component';
import { TreatmentApprovalComponent } from './treatment-approval/treatment-approval.component';
import { DeleteComponent } from './shared/components/delete/delete.component';
import { VerifyMail } from './verify-mail/verify-mail.component';
import { LicenseAgrementComponent } from './license-agrement/license-agrement.component';
import { PatientPaymentDetailsComponent } from './patient-payment-details/patient-payment-details.component';
import { RecentPaymentsComponent } from './recent-payments/recent-payments.component';
import { ChatMessengerComponent } from './chat-messenger/chat-messenger.component'
import { superAdminListingComponent } from './super-admin-listing-page/super-admin-listing.component';
import { ActivityReportListComponent } from './activity-report-list/activity-report-list.component';
import { OthersFailedPopupComponent } from './shared/components/others-failed-popup/others-failed-popup.component';
import { SuccessPopupComponent } from './shared/components/success-popup/success-popup.component';
import { FailurePopupComponent } from './shared/components/failure-popup/failure-popup.component';
import { PaymentDetailsPopupComponent } from './shared/components/payments-details-popup/patient-payment-details-popup.component'; 
import { ContractSignedComponent } from './shared/components/contract-signed/contract-signed.component';
import { LtrErrorPopupComponent } from './shared/components/ltr-error-popup/ltr-error-popup.component';

import { BaseWebService } from './shared/services/base-web.service';
import { SharedService } from './shared/services/shared.service';
import { SessionStorageService } from './shared/services/session-storage.service';
import { UtilService } from './shared/services/util.service';
import { RestrictOutsideScrollService } from "./shared/services/restrict-outside-scroll.service";
import { ActionRequiredListServcie } from './shared/components/action-required/action-required.service';

import { AuthResolver } from './shared/services/auth.resolver';
import { LoggedInResolver } from './shared/services/loggedIn.resolver';

let currentYear = new Date().getFullYear();

mobiscroll.settings = {
  theme: 'ios',
  themeVariant: 'light',
  display: 'bubble',
  dateFormat: "mm/dd/yy",
  returnFormat: 'locale',
  focusOnClose: false,
  defaultValue: new Date("01/01/" + currentYear)
};

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    MdlModule,
    MdlSelectModule,
    PracticeAppRoutingModule,
    HttpModule,
    HeaderNavModule,
    DeleteComponentModule,
    MenubarModule,
    BrowserAnimationsModule,
    MatDialogModule,
    ModalModule,
    PaginationModule,
    PatientAppViewModule,
    TranslateModule,
    PipeModule,
    NotFoundModule,
    DirectivesModule,
    CopyrightFooterModule,
    CommunicationMenuModule,
    PaymentMenuModule,
    InfiniteScrollModule,
    AngularDraggableModule,
    SettingsMenuModule,
    ImageCropperModule,
    ChangePasswordModule,
    MbscModule,
    AngularMultiSelectModule,
    MatTooltipModule,
    HttpClientModule,
    NgIdleModule.forRoot(),
    StripeAddNewPaymentModule,
  ],
  declarations: [
    PracticeAppComponent,
    LoginComponent,
    LogoutComponent,
    FollowUpCommunicationComponent,
    PatientOrthoFollowUpCommunicationComponent,
    RecentExpiredQuotesComponent,
    NonStartFollowUpCommunicationComponent,
    ParentOrthoFollowUpCommunicationComponent,
    SubscriptionComponent,
    ProfileComponent,
    DocusignComponent,
    StripeComponent,
    CartComponent,
    CartSuccessComponent,
    ContractCallback,
    VerifyMail,
    LicenseAgrementComponent,
    TreatmentApprovalComponent,
    DocusignApprovalCompleteComponent,
    PatientPaymentDetailsComponent,
    RecentPaymentsComponent,
    ChatMessengerComponent,
    StatementsComponent,
    VirtualCommunicationFollowUpComponent,
    superAdminListingComponent,
    ActivityReportListComponent,
    OthersFailedPopupComponent,
    SuccessPopupComponent,
    FailurePopupComponent,
    PaymentDetailsPopupComponent,
    ContractSignedComponent,
    LtrErrorPopupComponent
  ],
  entryComponents: [
    DeleteComponent,
    OthersFailedPopupComponent,
    SuccessPopupComponent,
    FailurePopupComponent,
    PaymentDetailsPopupComponent,
    ContractSignedComponent,
    LtrErrorPopupComponent,
  ],
  providers: [
    BaseWebService,
    SharedService,
    SessionStorageService,
    LoggedInResolver,
    AuthResolver,
    PaginationConfig,
    RestrictOutsideScrollService,
    ActionRequiredListServcie,
    { provide: 'utilService', useClass: UtilService }
  ],
  bootstrap: [ PracticeAppComponent ]
})
export class PracticeAppModule { }
